module.exports = __webpack_public_path__ + "img/htg3.ece11f8b.svg";